/*
 * Copyright (c) 2018 Integral Agile, Inc. All rights reserved.
 *   Use of this file is subject to the terms and conditions defined in the file
 * 'LICENSE.txt'
 *   which is distributed in the root directory of this source code tree.
 */

import Types from '../constants/actionTypes';

const initialState = {
  showGettingReady: false,
  showReady: true,
  showSprint: true,
  showWork: true,
  showDevComplete: false,
  showAccepted: false,
  showDeployed: false,
};

const viewReducer = (state = initialState, action) => {
  switch (action.type) {
    case Types.VIEW_GETTING_READY:
      return Object.assign({}, state, {
        showGettingReady: true,
        showReady: true,
        showSprint: false,
        showWork: false
      });
    case Types.VIEW_READY:
    case Types.VIEW_SPRINT:
    case Types.VIEW_WORK:
      return Object.assign({}, state, initialState);
    case Types.VIEW_DEV_COMPLETE:
      return Object.assign({}, state, {
        showReady: false,
        showDevComplete: true
      });
    case Types.VIEW_ACCEPTED:
      return Object.assign({}, state, {
        showSprint: false,
        showDevComplete: true,
        showAccepted: true
      });
    case Types.VIEW_DEPLOYED:
      return Object.assign({}, state, {
        showWork: false,
        showDeployed: true
      });
    default:
      return state;
  }
};

export default viewReducer;
